import { useState } from 'preact/hooks';
import * as S from '../app/state';
import { t, tn } from '../i18n';
import { Btn, Avatar, HeroPortrait, copyText, origin } from './common';
import { game } from '../game/client';
import { HeroCards } from './HeroSelect';
import { HeroSlots } from './Home';
import { heroesView, freeHeroSlot } from '../app/heroes';
import { api } from '../net/api';

export function Squad() {
  const sq = S.squad.value;
  const acc = S.account.value;
  const [code, setCode] = useState('');
  const me = sq?.members.find((m) => m.accountId === acc?.id);
  const leader = !!me?.leader;
  const link = sq ? `${origin()}#/s/${sq.code}${acc ? `?ref=${acc.id}` : ''}` : '';
  return (
    <div class="screen">
      <div class="card wide panel col">
        <div class="row">
          <h2>{t('btn.squad')}</h2>
          <div class="grow" />
          <Btn small onClick={() => (S.screen.value = 'home')}>
            {t('btn.back')}
          </Btn>
        </div>
        {!sq ? (
          <div class="col">
            <Btn primary onClick={() => game.send({ t: 'squad.create' })}>
              {t('btn.create')}
            </Btn>
            <div class="row">
              <input class="text grow" placeholder={t('label.code')} value={code} onInput={(e) => setCode((e.target as HTMLInputElement).value.toUpperCase())} />
              <Btn onClick={() => code && game.send({ t: 'squad.join', code: code.trim().toUpperCase() })}>{t('btn.join')}</Btn>
            </div>
          </div>
        ) : (
          <>
            <div class="row">
              <span class="muted">{t('label.code')}:</span>
              <b style={{ fontSize: 20, letterSpacing: '.15em' }}>{sq.code}</b>
              <div class="grow" />
              <Btn
                onClick={() => {
                  void copyText(t('label.shareSquad', { url: link }));
                  S.showToast(t('toast.copied'));
                  void api.event('share', { kind: 'squad' });
                }}
              >
                {t('btn.invite')}
              </Btn>
            </div>
            <div class="list">
              {sq.members.map((m) => (
                <div class="member">
                  <Avatar i={m.avatar} />
                  <HeroPortrait hero={m.heroId} size={28} />
                  <div class="col" style={{ gap: 0 }}>
                    <b>
                      {m.name} {m.leader && <span class="gold">★</span>} {m.accountId === acc?.id && <span class="muted small">({t('label.you')})</span>}
                    </b>
                    <span class="small muted">
                      {tn('hero', m.heroId)}
                      {m.level ? ` · ${t('label.rankShort')} ${m.level}` : ''} · {m.inGame ? t('label.inGame') : t('label.ready')}
                    </span>
                  </div>
                  <div class="grow" />
                  {leader && m.accountId !== acc?.id && (
                    <Btn small onClick={() => game.send({ t: 'squad.leave' })} title={t('btn.kick')} disabled>
                      {t('btn.kick')}
                    </Btn>
                  )}
                </div>
              ))}
            </div>
            <h3>{t('label.heroes')}</h3>
            <HeroSlots compact onSelect={(slot, save) => game.send({ t: 'squad.hero', heroId: save?.heroId ?? S.heroChoice.value, slot })} />
            {!heroesView().heroes.some((h) => h.slot === S.slotChoice.value) && (
              <>
                <h3>{t('btn.chooseHero')}</h3>
                <HeroCards
                  compact
                  selected={S.heroChoice.value}
                  onSelect={(h) => {
                    const slot = freeHeroSlot();
                    if (slot < 0) {
                      S.showToast(t('label.slotsAllTakenHint'));
                      return;
                    }
                    S.setHero(h);
                    S.setSlot(slot);
                    game.send({ t: 'squad.hero', heroId: h, slot });
                  }}
                />
              </>
            )}
            <div class="row">
              <Btn primary block disabled={!leader} onClick={() => game.send({ t: 'squad.start', mode: 'realm' })}>
                {t('btn.start')}: {t('label.realm')}
              </Btn>
              <Btn block disabled={!leader || sq.members.length !== 2} onClick={() => game.send({ t: 'squad.start', mode: 'duel' })}>
                {t('btn.start')}: {t('btn.duel')}
              </Btn>
              <Btn danger onClick={() => game.send({ t: 'squad.leave' })}>
                {t('btn.leave')}
              </Btn>
            </div>
            {!leader && <div class="small muted center">{t('label.leader')}: {sq.members.find((m) => m.leader)?.name}</div>}
          </>
        )}
      </div>
    </div>
  );
}
